import { SubscriptionType } from "types/SubscriptionTypes";

export const hasNextPayment = (subscription: SubscriptionType): boolean => {
  return !!(
    subscription.current_period_end &&
    subscription.items.total_count > 0 &&
    !subscription.canceled_at
  );
};
